import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, TextField, Icon, Button, Drawer, Switch, InputAdornment, Paper } from '@mui/material';
import IconButton from '@material-ui/core/IconButton';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { IconLink } from '@tabler/icons-react';
import TestConnection from '../Modal/TestConnection';
import axios from '@fuse/utils/axios';
import { Autocomplete } from '@material-ui/lab'
import { generateProperLocationString } from '@fuse/utils/general';
import AlphabeticalSorting from '@fuse/utils/alphabeticalSort';
import AddLocationFromQuickAction from 'app/fuse-layouts/shared-components/modal/AddLocationFromQuickAction';
import { useDispatch } from 'react-redux';
import { toggleProgressBarVisibility } from '../store/dataSyncReducer';
import useToast from '@fuse/hooks/useToast';
import DeleteConfirmModal from 'helper/DeleteConfirm';
import AlertModal from 'helper/alertModal';

const useStyles = makeStyles(theme => (
  {
    drawerWidth: {
      width: 520,
      borderTopLeftRadius: '8px',
      borderBottomLeftRadius: '8px',
      overflowX: 'hidden',
      overflowY: 'hidden'
    },
  }
))

function ConnectSalto({ openSaltoDrawer, handleCloseForm, getConnectorDashboardMatrix, syncDataFromSalto, onClickSaltoTestConnection }) {
  const classes = useStyles();
  const dispatch = useDispatch()
  const toast = useToast(dispatch)
  const [checkedLock, setCheckedLock] = useState(false);
  const [checkedAccess, setCheckedAccess] = useState(false);
  const [checkedLiveLock, setCheckedLiveLock] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [openTestConnectionModal, setOpenTestConnectionModal] = useState(false);
  const [testConnectionIsLoading, setTestConnectionIsLoading] = useState(false);
  const [testConnectionFailed, setTestConnectionFailed] = useState(false);
  const [locationMenu, setLocationMenu] = useState([]);
  const [newLocationIndex, setNewLocationIndex] = useState();
  const [trigger, setTrigger] = useState(new Date());
  const [ openAddLocationModal, setOpenAddLocationModal ] = useState(false)
	const [ openDeleteDialog, setOpenDeleteDialog ] = useState(false)
	const [ deleteIndex, setDeleteIndex ] = useState()
  const [openAlerModal, setOpenAlertModal] = useState(false);
  const [ saltoConnectionStatus, setSaltoConnectionStatus ] = useState('connected')

  //form validation 
  const schema = yup.object({
    siteIDArray: yup.array().of(yup.object({
      siteID: yup.string().trim().required("Site ID is required."),
      locationDetail: yup.object().required("Location is required.")
    })).required("Site ID is required."),
  })

  const defaultValues = {
    siteIDArray: [{ siteID: '', locationDetail: null }]
  }

  const { control, formState: { errors }, handleSubmit, reset, setValue, getValues } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema)
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "siteIDArray",
  });

  function addAnOtherSiteId() {
    append({ siteID: '', locationDetail: null })
  }

  function removeSiteId(){
    remove(deleteIndex)
    const newArr = getValues().siteIDArray
    reset({ 'siteIDArray': newArr })
    setOpenDeleteDialog(false)

    toast.success('To ensure data continuity, please contact our support team to archive these assets')
  }

  function handleOnClickConnectButton(formData) {
    axios.post(`/salto/connect-salto`, {
      sites_details: formData.siteIDArray.map(item => {
        return {
          site_id: item.siteID,
          location_id: item.locationDetail.id,
          location_entity_external_platform_id: item.locationDetail.entity_external_platform_id
        }
      })
    }).then((res) => {
      setDefault()
      getConnectorDashboardMatrix()
      syncDataFromSalto()
    }).catch((err) => {
      toast.error(err?.response?.data?.message || "Something went wrong")
      console.log(err)
    }).finally(() => {

    })
  }

  function setDefault() {
    handleCloseForm()
    reset(defaultValues)
  }

  const toggleShowPassword = () => setShowPassword((show) => !show);

  const handleCloseTestConnection = () => {
    setOpenTestConnectionModal(false)
    setTestConnectionIsLoading(false)
    setTestConnectionFailed(false)
  };

  function testApiConnection(formData) {
    setTestConnectionIsLoading(true)
    axios.post(`/salto/test-connection`, {
      sites_details: formData.siteIDArray.map(item => {
        return {
          site_id: item.siteID,
          location_id: item.locationDetail.id,
          location_entity_external_platform_id: item.locationDetail.entity_external_platform_id
        }
      })
    }).then((res) => {
      setTestConnectionFailed(false)
    }).catch((err) => {
      setTestConnectionFailed(true)
    }).finally(() => {
      setTestConnectionIsLoading(false)
      onClickSaltoTestConnection()
    })
  }

  const handleAlertModal=(_, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setOpenAlertModal(!openAlerModal)
  }

  const handleCloseAlertModal=() =>{
    setOpenAlertModal(false)
    setDefault()
  }
  const handleOpenTestConnection = (formData) => {
    setOpenTestConnectionModal(true)
    testApiConnection(formData)
  }

  const handleOpenCloseAddLocation = (index = undefined) => {
    setNewLocationIndex(index)
    setOpenAddLocationModal(!openAddLocationModal)
  }

  const newLocationAddedEvent = (createdData) => {
    setOpenAddLocationModal(!openAddLocationModal)

    // setValue(`siteIDArray.${newLocationIndex}.locationDetail`, {
    //       entity_external_platform_id: createdData.entity_external_platform_id,
    //       id: createdData.id,
    //       location_name: createdData.location_name,
    //       address1: createdData.address1 || '',
    //       address2: createdData.address2 || '',
    //       city: createdData.city || '',
    //       state: createdData.state || '',
    //       country: createdData.country || '',
    //   });
    // setNewLocationIndex()
    const newObj = getValues().siteIDArray

    newObj[newLocationIndex].locationDetail ={
      entity_external_platform_id: createdData.entity_external_platform_id,
      id: createdData.id,
      location_name: createdData.location_name,
      address1: createdData.address1 || '',
      address2: createdData.address2 || '',
      city: createdData.city || '',
      state: createdData.state || '',
      country: createdData.country || '',
    }
    setValue("siteIDArray", newObj);
    setTrigger(+new Date())
    setNewLocationIndex()
    fetchLocationSuggestions('', true)
  }


  const fetchLocationSuggestions = (value = '', isNew=false) => {
    axios.get(`assets/fetch-location-suggestion?value=${value}`).then(response => {
      let locations = (AlphabeticalSorting(response.data.data.locations,'location_name'))
      setLocationMenu(locations)
      if(!isNew){
        getSaltoAccountDetails(locations)
      }
    }).catch(err => {
      console.log('error',err);
    })
	}

  function getSaltoAccountDetails(locations=[]){
    axios.get(`/salto/get-salto-details`).then(response => {
      if(response.data.data.details){
        const {
          sites_details,
          status
        } = response.data.data.details;

        const editDataForSiteDetails = sites_details.map((item)=>{
          return {
            siteID: item.site_id,
            locationDetail: locations.find(i => i.id === item.location_id)
          }
        });

        reset({ 'siteIDArray': editDataForSiteDetails })
        setSaltoConnectionStatus(status)
      }
		}).catch(err => {
			console.log('error',err);
		})
  }

  useEffect(()=>{
    fetchLocationSuggestions()
  },[]);

  const handleConfirm = (index) => {
		setOpenDeleteDialog(true)
		setDeleteIndex(index)
	}

  const handleClose = () => {
		setOpenDeleteDialog(false)
    setDeleteIndex()
	}

  return (
    <>
      <Drawer anchor='right' open={openSaltoDrawer} classes={{ paper: classes.drawerWidth }} className='cstm_drawer_holder bottom_border'>
        <div className='heading_holder'>
          <h4 className='heading'>{(getValues('salto_client_id') && saltoConnectionStatus === 'connected') ? 'Edit' : "Connect"} Salto</h4>
          <IconButton onClick={() => handleAlertModal()} style={{ padding: '0px' }}>
            <Icon style={{ fontSize: '24px', color: '#1d2939' }}>close</Icon>
          </IconButton>
        </div>

        <div className='cstm_wizard_holder'>
          <Box sx={{ width: '100%', paddingTop: '30px' }} className='box_holder'>
            <div className='main_content_holder'>
              <div className='content_holder'>
                <div className="text-left pb-28 border_bottom">
                  {
                    fields.map((item, index) => (
                      <React.Fragment key={item.id}>
                        <div className='mb-10'>
                          <Typography className='status_text'>
                            Site ID
                            <span className='required_span'>*</span>
                          </Typography>
                          <Controller
                            name={`siteIDArray.${index}.siteID`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                name=""
                                variant='outlined'
                                fullWidth
                                error={!!errors?.siteIDArray?.[index]?.siteID}
                                helperText={errors?.siteIDArray?.[index]?.siteID?.message}
                                FormHelperTextProps={{
                                  style: {
                                    margin: 0,
                                    backgroundColor: '#f4f4f4',
                                    width: '100%',
                                    paddingTop: '2px',
                                    fontSize: '10px',
                                  }
                                }}
                                style={{ width: '100%', backgroundColor: '#fff' }}
                              />
                            )}
                          />
                          <div className='mb-10 mt-10'>
                            <Typography className='status_text'>
                              Location
                              <span className='required_span'>*</span>
                            </Typography>
                            <Controller
                              name={`siteIDArray.${index}.locationDetail`}
                              className="mb-16"
                              control={control}
                              render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                <>
                                  <Autocomplete
                                    {...field}
                                    key={trigger}
                                    style={{ width: '100%' }}
                                    className='main_autocomplete'
                                    options={locationMenu}
                                    onChange={(event, value) => field.onChange(value)}
                                    PaperComponent={({ children }) => (
                                      <Paper className='autocomplete_holder'>{children}
                                        <div className='p-16'>
                                          <Button className='secondary_btn w-full' onMouseDown={() => handleOpenCloseAddLocation(index)}>
                                            <i className='ti ti-plus' />
                                            <span>Add Location</span>
                                          </Button>
                                        </div>
                                      </Paper>
                                    )}
                                    getOptionLabel={
                                      option => {
                                        return generateProperLocationString({
                                          location_name: option?.location_name ?? '',
                                          address1: option?.address1 ?? '',
                                          address2: option?.address2 ?? '',
                                          city: option?.city ?? '',
                                          state: option?.state ?? '',
                                          country: option?.country ?? ''
                                        })
                                      }
                                    }
                                    renderInput={(params) => {
                                      return (
                                        <div ref={params.InputProps.ref}>
                                          <TextField
                                            {...params}
                                            key={trigger}
                                            style={{ background: 'white' }}
                                            required
                                            error={!!errors?.siteIDArray?.[index]?.locationDetail}
                                            helperText={errors?.siteIDArray?.[index]?.locationDetail?.message && "Location is required"}
                                            FormHelperTextProps={{
                                              style: {
                                                margin: 0,
                                                backgroundColor: '#f4f4f4',
                                                width: '100%',
                                                paddingTop: '2px',
                                                fontSize: '10px'
                                              }
                                            }}
                                            variant="outlined"
                                            fullWidth
                                          />
                                        </div>
                                      )
                                    }}
                                  />
                                </>
                              )}
                            />
                          </div>
                          <div className='flex justify-end pt-4'>
                            <Button
                              onClick={addAnOtherSiteId}
                              style={{ marginRight: '10px'}}
                              className='add_anotherButton mt-0 mr-3 p-1 capitalize'
                              startIcon={
                                <Icon fontSize="small" title="Add Another">
                                  add
                                </Icon>}>
                              Add Another
                            </Button>
                            {fields.length !== 1 && <Button
                              onClick={() => handleConfirm(index)}
                              className='add_anotherButton mt-0 mr-3 p-1 capitalize'
                              startIcon={
                                <Icon fontSize="small" title="Remove">
                                  delete
                                </Icon>}>
                              Remove
                            </Button>}
                          </div>
                        </div>
                      </React.Fragment>
                    ))
                  }

                  <div className='test_connection'>
                    <span style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handleSubmit(handleOpenTestConnection)}>
                      <IconLink />
                      <span className='pl-4'>Test Connection</span>
                    </span>
                  </div>
                </div>

                <div className="text-left pt-28">
                  <h4 className='submain_heading'>Synchronization Settings(Optional)</h4>
                  <div className='sub_content pb-16'>Specify the data you wish to sync</div>

                  <div className='flex justify-between items-center mb-16'>
                    <label className='normal_label_holder'>Lock Status</label>
                    <Switch
                      checked={checkedLock}
                      onChange={(event) => setCheckedLock(event.target.checked)}
                      disableRipple
                      sx={{
                        '& .MuiSwitch-switchBase': {
                          padding: '14px', // Adjust padding to align the thumb

                          '&:hover': {
                            backgroundColor: 'transparent'
                          },
                          '&.Mui-checked': {
                            color: '#66bb6a', // Thumb color when checked
                            transform: 'translateX(16px)', // Move thumb when checked
                            '& + .MuiSwitch-track': {
                              backgroundColor: '#66bb6a', // Track color when checked
                            },
                          },
                        },
                        '& .MuiSwitch-thumb': {
                          backgroundColor: '#ffffff',
                          width: 16,
                          height: 16,
                        },
                        '& .MuiSwitch-track': {
                          width: 36,
                          height: 20,
                          backgroundColor: '#EAECF0',
                          borderRadius: 16,
                          opacity: 1
                        },
                      }}
                    />
                  </div>

                  <div className='flex justify-between items-center mb-16'>
                    <label className='normal_label_holder'>Access Events</label>
                    <Switch
                      checked={checkedAccess}
                      onChange={(event) => setCheckedAccess(event.target.checked)}
                      disableRipple
                      sx={{
                        '& .MuiSwitch-switchBase': {
                          padding: '14px', // Adjust padding to align the thumb

                          '&:hover': {
                            backgroundColor: 'transparent'
                          },
                          '&.Mui-checked': {
                            color: '#66bb6a', // Thumb color when checked
                            transform: 'translateX(16px)', // Move thumb when checked
                            '& + .MuiSwitch-track': {
                              backgroundColor: '#66bb6a', // Track color when checked
                            },
                          },
                        },
                        '& .MuiSwitch-thumb': {
                          backgroundColor: '#ffffff',
                          width: 16,
                          height: 16,
                        },
                        '& .MuiSwitch-track': {
                          width: 36,
                          height: 20,
                          backgroundColor: '#EAECF0',
                          borderRadius: 16,
                          opacity: 1
                        },
                      }}
                    />
                  </div>

                  <div className='flex justify-between items-center'>
                    <label className='normal_label_holder'>Live Lock Status</label>
                    <Switch
                      checked={checkedLiveLock}
                      onChange={(event) => setCheckedLiveLock(event.target.checked)}
                      disableRipple
                      sx={{
                        '& .MuiSwitch-switchBase': {
                          padding: '14px', // Adjust padding to align the thumb

                          '&:hover': {
                            backgroundColor: 'transparent'
                          },
                          '&.Mui-checked': {
                            color: '#66bb6a', // Thumb color when checked
                            transform: 'translateX(16px)', // Move thumb when checked
                            '& + .MuiSwitch-track': {
                              backgroundColor: '#66bb6a', // Track color when checked
                            },
                          },
                        },
                        '& .MuiSwitch-thumb': {
                          backgroundColor: '#ffffff',
                          width: 16,
                          height: 16,
                        },
                        '& .MuiSwitch-track': {
                          width: 36,
                          height: 20,
                          backgroundColor: '#EAECF0',
                          borderRadius: 16,
                          opacity: 1
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='btn_holder'>
                <Button className='primary_btn' onClick={handleSubmit(handleOnClickConnectButton)}>Sync Data</Button>
              </div>
            </div>
          </Box>
        </div>
        {openTestConnectionModal &&
          <TestConnection
            open={openTestConnectionModal}
            close={handleCloseTestConnection}
            testConnectionIsLoading={testConnectionIsLoading}
            testConnectionFailed={testConnectionFailed}
            onClickReTry={handleSubmit(testApiConnection)}
          />
        }

        {
					openDeleteDialog && 

					<DeleteConfirmModal
						openAlerModal={openDeleteDialog}
						module={'Site Details'}
						handleCloseAlertModal={handleClose} 
						handleAlertModal={removeSiteId}
					/>
				}
      </Drawer>
      {
        openAddLocationModal && 
        <AddLocationFromQuickAction
          handleOpenCloseAddModalEvent={handleOpenCloseAddLocation}
          openAddStatusModalStateData={openAddLocationModal}
          newDataAddedEvent={newLocationAddedEvent}
        />
      }
      {openAlerModal &&
        <AlertModal
          openAlerModal
          module="salto"
          action= {(getValues('salto_client_id') && saltoConnectionStatus === 'connected') ? 'updating' :'connecting'}
          handleCloseAlertModal={handleCloseAlertModal}
          handleAlertModal={handleAlertModal}
        />
      }
    </>
  )
}

export default ConnectSalto